import className from '../../../common/className.js'
import Select from '../../../common/components/Select.js'
import {TIME_ZONE_OPTIONS} from '../../../common/constants/TimeZones.js'
import {updateForm, useForm} from '../../../store.js'

export default function TimeZone({formName, dividerButton}) {
  dividerButton = dividerButton === false ? false : true
  const form = useForm(formName)

  return (
    <li
      className={className`list__item--form list__item--no-style ${
        dividerButton && 'divider--bottom'
      } margin-bottom-15 padding-bottom-20`}
    >
      <div>
        <label htmlFor="id_time_zone">Time Zone</label>
        <Select
          className="w-100 margin-bottom-0"
          id="id_timezone"
          value={form.timezone}
          onChange={(timezone) =>
            updateForm(formName, {timezone}, {stickyProps: ['timezone']})
          }
        >
          {TIME_ZONE_OPTIONS.map(({value, display}) => (
            <option value={value} key={value}>
              {display}
            </option>
          ))}
        </Select>
      </div>
    </li>
  )
}
